import {
    request,
    requestPublic
} from './request.js'
// 获取普本院校列表
export function getPagination(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/GetPagination',
        method: 'get',
        params: {
            PageSize: obj.pageSize,
            PageNumber: obj.pageNumber,
            Name: obj.name,
            Nature: obj.nature,
            Types: obj.types
        }
    })
}

// 获取普本院校详情
export function getSchoolPt(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/GetSchoolPt',
        method: 'get',
        params: {
            id: id
        }
    })
}

//添加普本院校
export function addSchoolPt(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/AddSchoolPt',
        method: 'post',
        data: data
    })
}

//修改普本院校
export function modifySchoolPt(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/ModifySchoolPt',
        method: 'post',
        data: data
    })
}

//删除普本院校
export function removeSchoolPt(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/RemoveSchoolPt',
        method: 'post',
        params: {
            id: id
        }
    })
}

//获取普本院校性质
export function getAllSchoolPtNature() {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/GetAllSchoolPtNature',
        method: 'get'
    })
}
//获取普本院校类别
export function getAllSchoolPtTypes() {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/GetAllSchoolPtTypes',
        method: 'get'
    })
}

//获取普本院校所有的城市
export function getAllCities() {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/GetAllCities',
        method: 'get'
    })
}

//根据条件获取普本院校列表
export function getConditionsList(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SchoolPt/GetPbSchoolList',
        method: 'post',
        data:data
    })
}


// 发布普本院校页面
export function CreatePbSchoolHtml(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/HtmlRelease/CreatePbSchoolHtml?id=' + id,
        method: 'post',
    })
}

// 发布普本院校招生动态页面
export function CreatePbSchoolChannelHtml(schoolPtId) {
    return request({
        url: '/api2/ZsbSiteAdmin/HtmlRelease/CreatePbSchoolChannelHtml?schoolPtId=' + schoolPtId,
        method: 'post',
    })
}